declare global {
  interface Window {
    dataLayer?: any[];
  }
}

type TrackingEvent = {
  category: string;
  action: string;
  label?: string;
};

export const trackEvent = ({ category, action, label }: TrackingEvent): void => {
  // note - need to handle when dataLayer not initialised - for dev
  (window.dataLayer || []).push({
    event: 'event',
    eventProps: {
      category,
      action,
      label
    }
  });
};
